const { validatePostalCode } = require('public/js/lib/postal-code-helper');

const inStockAndInStockOnlyWarehouseTypes = [
	'StockLevel',
	'InStockMessagingWithWarehouseOnly',
];

const getInventoryMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	let inventoryMessage = (displayStockLevel ? message.inventoryMessage.inventory_message : message.inventoryMessage) || '';
	if (message.inventoryMessageType === 'OutOfStockMessagingOnly') {
		inventoryMessage = `<i class="fa fa-exclamation-triangle"></i> ${inventoryMessage}`;
	}

	return inventoryMessage;
};

const getShippingMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.shipping_message : null) || '';
};

const getShippingMessageTitle = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.shipping_message_title : null) || '';
};

const getShippingEstimateMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.shipping_estimate_message : null) || '';
};

const getInventoryMessageWarehouseId = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.warehouse_id : null) || '';
};

const getInventoryMessageCustomerId = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.warehouse_customer_id : null) || '';
};

const getPickupMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.pickup_message : null) || '';
};

const handleZipSubmissionError = (errorMessage) => {
	const $formErrors = rp$('#shippingZipError');
	$formErrors.html(`${errorMessage}`);
};

const handleZipChangeResponse = (response) => {
	const $shippingEstimateMessageContentEle = rp$('#rp_shipping_estimate_message');
	$shippingEstimateMessageContentEle.html(response.message);
	handleZipChangeEvent();
};

const handleZipChangeEvent = () => {
	rp$('.shipping-estimate-postal-code').on('click', (evt) => {
		evt.preventDefault();
		const $formErrors = rp$('#shippingZipError');
		$formErrors.html('');
		const zipCode = rp$('.shipping-estimate-postal-code').text();
		rp$('.zip-code-input').val(zipCode);
	});
};

const handleZipChange = (customerId, warehouseId, zipCode) => {
	const $modalBody = rp$('.modal-body', '.zip-code-modal');
	const $formErrors = rp$('#shippingZipError');
	if (!validatePostalCode(zipCode)) {
		return handleZipSubmissionError($modalBody.data('error-invalid-zip'));
	} else {
		$formErrors.html('');
		$ajax({
			method: 'GET',
			dataType: 'json',
			data: {
				customerId,
				warehouseId,
				zipCode,
			},
			url: '/ajax/product/get-shipping-message-for-postal-code',
			success: (response) => {
				if (response.status === 'success') {
					rp$('.modal-backdrop').css('display', 'none');
					rp$('#zipCodeModal').modal('hide');
					handleZipChangeResponse(response);
				} else {
					handleZipSubmissionError($modalBody.data('error-invalid-zip'));
				}
			},
			statusCode: {
				400: () => {
					handleZipSubmissionError($modalBody.data('error-400'));
				}
			},
			error: () => {
				handleZipSubmissionError($modalBody.data('error-500'));
			}
		});
	}
	rp$('.zip-code-modal').click();
};

module.exports = {
	getInventoryMessage,
	getShippingMessageTitle,
	getShippingMessage,
	getShippingEstimateMessage,
	getPickupMessage,
	getInventoryMessageWarehouseId,
	getInventoryMessageCustomerId,
	handleZipChange,
	handleZipChangeEvent,
};